import 'axios-interceptors'
import store from '../store'
import VueCookies from 'vue-cookies'
import VueJwtDecode from "vue-jwt-decode";

export function setInterceptors (axiosService) {
    axiosService.interceptors.request.use(
        function (config) {
            if (!VueCookies.isKey('dms-user-token')) {
                store.dispatch('getToken')
            }
            config.headers.Authorization = 'Bearer ' + VueCookies.get('dms-user-token')

            return config
        }, function (error) {
            return Promise.reject(error)
        }
    )

    axiosService.interceptors.response.use(function (response) {
            if (response.status === 200) {
                if (response.data.code !== undefined) {
                    if (response.data.code === '9401' || response.data.code === '9499') { // 미인증사용자, 토큰만료
                        store.commit('setDenyCode', response.data.code)
                        window.location.href = '/exp-error'
                    }
                }
            }
            return response
        }, async function (error) {
            let hasToken = VueCookies.get('dms-user-token')

            if (hasToken) {
                const decToken = VueJwtDecode.decode(hasToken)
                if (!decToken) {
                    store.dispatch('getToken')
                }
            }
            return Promise.reject(error)
        }
    )

    return axiosService
}
